import React from 'react';

import { SimpleTooltip } from '@eluve/components';
import {
  Button,
  Icon,
  IconName,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Stack,
  Text,
} from '@eluve/components';

export interface DeviceInfo {
  deviceType: string | null;
  manufacturer: string | null;
  model: string | null;
  browserName: string | null;
  operatingSystem: string | null;
  microphoneName: string | null;
}

interface DeviceInfoPopoverProps {
  device: DeviceInfo | null;
}

const getDeviceIcon = (deviceType: string | null): IconName => {
  switch (deviceType) {
    case 'mobile':
      return 'Smartphone';
    case 'tablet':
      return 'Tablet';
    default:
      return 'Monitor';
  }
};

const deviceFields: { key: keyof DeviceInfo; label: string }[] = [
  { key: 'deviceType', label: 'Device Type' },
  { key: 'manufacturer', label: 'Manufacturer' },
  { key: 'model', label: 'Model' },
  { key: 'browserName', label: 'Browser' },
  { key: 'operatingSystem', label: 'Operating System' },
  { key: 'microphoneName', label: 'Microphone' },
];

export const DeviceInfoPopover: React.FC<DeviceInfoPopoverProps> = ({
  device,
}) => {
  const hasDevice = device !== null;
  const iconName = getDeviceIcon(device?.deviceType ?? null);

  return (
    <Popover>
      <SimpleTooltip label="Device Info">
        <PopoverTrigger asChild>
          <Button variant="outline" disabled={!hasDevice}>
            <Icon name={iconName} size="auto" />
          </Button>
        </PopoverTrigger>
      </SimpleTooltip>
      <PopoverContent className="w-80" align="start">
        <Stack gap={4}>
          <Text>Device Info</Text>
          {device &&
            deviceFields.map(({ key, label }) => (
              <Stack
                key={key}
                align="center"
                justify="between"
                className="rounded-md border p-2 pl-3"
                gap={2}
                direction="horizontal"
              >
                <div className="min-w-0 flex-1">
                  <Text size="xs">{label}</Text>
                  <Text className="truncate" color="tertiary" size="xs">
                    <span title={device[key] ?? 'N/A'}>
                      {device[key] ?? 'N/A'}
                    </span>
                  </Text>
                </div>
              </Stack>
            ))}
        </Stack>
      </PopoverContent>
    </Popover>
  );
};
